import React, { memo } from 'react';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

import checkIcon from '../../assents/img/check.svg';
import { BACKEND_URL } from '../../constans';

const ModalWrap = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '101vh',
    backgroundColor: '#ffffff',
    overflowY: 'auto',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
    '&:focus': {
        outline: 'none',
    },
    [theme.breakpoints.up('sm')]: {
        maxWidth: '1184px',
        height: '561px',
        borderRadius: '10px',
        overflowY: 'hidden',
    },
}));

const ModalHeader = styled(Box)(({ theme }) => ({
    width: '100%',
    padding: '25px 20px 0',
    boxSizing: 'border-box',
    [theme.breakpoints.up('sm')]: {
        padding: '30px 24px 0',
    },
}));

const ModalHeaderTitle = styled(Typography)(({ theme }) => ({
    marginBottom: '26px',
    fontFamily: 'Rubik',
    fontWeight: 500,
    fontSize: '26px',
    lineHeight: 1.2,
    color: '#1a1a1a',
    [theme.breakpoints.up('sm')]: {
        marginBottom: '31px',
        fontSize: '30px',
        lineHeight: 1.2,
    },
}));

const CloseButton = styled(Button)(() => ({
    position: 'absolute',
    top: '28px',
    right: '20px',
    height: '33px',
    width: '68px',
    padding: '8px',
    background: 'rgba(0, 0, 0, 0.05)',
    borderRadius: '5px',
    border: 'none',
    fontFamily: 'Proxima Nova',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: 1.211,
    color: '#1a1a1a',
    boxSizing: 'border-box',
    textTransform: 'none',
    '&:hover': {
        background: 'rgba(0, 0, 0, 0.05)',
    },
    '& .MuiButton-startIcon': {
        marginRight: '3px !important',
        marginLeft: '0 !important',
    },
}));

const CloseIconCustom = styled(CloseIcon)(() => ({
    fontSize: '11px !important',
}));

const ModalBody = styled(Box)(({ theme }) => ({
    width: '100%',
    padding: '0 20px 25px',
    boxSizing: 'border-box',
    [theme.breakpoints.up('sm')]: {
        padding: '0 24px 30px',
    },
}));

const ToursList = styled(List)(({ theme }) => ({
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    [theme.breakpoints.up('sm')]: {
        gap: '24px',
    },
}));

const TourCard = styled(ListItem)(({ theme, img }) => ({
    width: '335px',
    height: '208px',
    position: 'relative',
    padding: 0,
    backgroundImage: `url(${img})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '10px',
    cursor: 'pointer',
    [theme.breakpoints.up('sm')]: {
        overflow: 'hidden',
        width: '208px',
        height: '208px',
    },
}));

const SelectedWrap = styled(Box)(() => ({
    width: '95px',
    height: '32px',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#eaf8ee',
    borderRadius: '100px',
    boxSizing: 'border-box',
    position: 'absolute',
    top: '10px',
    left: '10px',
}));

const SelectedText = styled(Typography)(() => ({
    fontFamily: 'Proxima Nova',
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: 1.214,
    display: 'flex',
    alignItems: 'center',
    color: '#2bb656',
}));

const ImgBackground = styled(Box)(({ theme }) => ({
    height: '150px',
    position: 'absolute',
    opacity: 0.7,
    width: '100%',
    bottom: '0px',
    background: 'linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%)',
    borderRadius: '10px',
}));

const TourName = styled(Typography)(() => ({
    position: 'absolute',
    bottom: '20px',
    left: '20px',
    width: '168px',
    fontFamily: 'Proxima Nova',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: 1.25,
    color: '#ffffff',
}));

const ChangeTourRouteModal = memo(({ allRoutes, currentTourId, open, handleClose }) => {
    return (
        <Modal open={open} onClose={handleClose}>
            <ModalWrap>
                <ModalHeader>
                    <CloseButton startIcon={<CloseIconCustom />} onClick={handleClose}>
                        Close
                    </CloseButton>
                    <ModalHeaderTitle>Change tour route</ModalHeaderTitle>
                </ModalHeader>
                <ModalBody>
                    <ToursList>
                        {allRoutes?.map((el) => (
                            <TourCard
                                key={el.id}
                                onClick={() => (window.location.href = `/tourbuilder/${el.tour.slug}`)}
                                img={`${BACKEND_URL}${el.image}`}
                            >
                                {currentTourId === el.id && (
                                    <SelectedWrap>
                                        <img src={checkIcon} alt='check icon' />
                                        <SelectedText>Selected</SelectedText>
                                    </SelectedWrap>
                                )}
                                <ImgBackground />
                                <TourName>{el.name}</TourName>
                            </TourCard>
                        ))}
                    </ToursList>
                </ModalBody>
            </ModalWrap>
        </Modal>
    );
});

export default ChangeTourRouteModal;
